/* eslint-disable import/prefer-default-export */
import gql from "graphql-tag";

export const GET_CHALLENGE = gql`
  query GET_CHALLENGE {
    getChallenge {
        id
        title
        description
        explanation
        emptyStateImage
        rewardImage
        rewardCompleteImage
        rewardStep1Image
        rewardStep1CompleteImage
        rewardStep2Image
        rewardStep2CompleteImage
        rewardStep3Image
        rewardStep3CompleteImage
        rewardStep4Image
        rewardStep4CompleteImage
        rewardStep5Image
        rewardStep5CompleteImage
        customerLevel
        actionCountRequired
        learnMoreText
        endDateTime
        step1Image
        step1Title
        step1Description
        step2Image
        step2Title
        step2Description
        rewardProduct {
          id
          title
          hasAssortments
          options {
            id
            title
          }
        }
        customerAward {
          id
          isRedeemed
        }
    }
  }
`;